module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.912ec66d.svg";